var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitoringIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#511FFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M473-132q-70-2-132.5-29.5T232-236q-46-47-73-109.77-27-62.77-27-134.23 0-72 27.5-135.5T234-726q47-47 110.5-74.5T480-828q139 0 238.5 93T828-505h-22q-7-94-61.5-169.5T602-785v19q0 34-23.5 58T521-684h-82v82q0 16.58-12 28.29T398-562h-81v82h81v121h-40L162-554q-3 18-5.5 36.67Q154-498.67 154-480q0 132 92 227.5T473-154v22Zm369-10L699-283q-17 14-37.5 21t-41.07 7q-52.01 0-88.72-36.62T495-380.12q0-51.88 36.62-88.38 36.62-36.5 88.5-36.5t88.38 36.71q36.5 36.71 36.5 88.72 0 21.57-7.5 42.57T715-299l143 141-16 16ZM619.86-277Q663-277 693-306.86t30-73Q723-423 693.14-453t-73-30Q577-483 547-453.14t-30 73Q517-337 546.86-307t73 30Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoringIcon);
export default __webpack_public_path__ + "static/media/monitoring-icon.2bf64a0ebc2d0da01052973203541ce8.svg";
export { ForwardRef as ReactComponent };